import { useEffect, useRef, useState } from "react"
import { fromSecToMinSec } from "../utils/timeUtils"

interface CountdownTimerProps {
    initialTime: number
    onComplete?: () => void
    skipMin?: boolean
}

export const useCountdownTimer = ({
    initialTime,
    onComplete,
    skipMin = false,
}: CountdownTimerProps) => {
    const [timeLeft, setTimeLeft] = useState(initialTime)
    const hasCompleted = useRef(false)
    useEffect(() => {
        setTimeLeft(initialTime)
        hasCompleted.current = false
    }, [initialTime])

    useEffect(() => {
        if (
            // @ts-expect-error no timer for storybook
            window["IS_STORYBOOK"] === true ||
            timeLeft <= 0 ||
            hasCompleted.current
        ) {
            return
        }

        const timer = setTimeout(() => {
            setTimeLeft((prevTime) => prevTime - 1)
        }, 1000)

        return () => clearTimeout(timer)
    }, [timeLeft, onComplete])

    useEffect(() => {
        if (timeLeft === 0 && !hasCompleted.current) {
            hasCompleted.current = true
            onComplete?.()
        }
    }, [timeLeft, onComplete])

    return { timeLeft: skipMin ? timeLeft : fromSecToMinSec(timeLeft) }
}
